require('angular').module('wowApp.common')
    .service('SettingsService', ['Restangular', '$rootScope', '$q', 'BootstrapService', require('./settings-service')])
    .factory('SettingsByBreakpointService', ['$q', 'SettingsService', 'BreakpointsService', require('./settings-by-breakpoint-service')])
    .directive('wowSetting', ['SettingsService', require('./settings-directive')])
    .directive('wowHtmlSetting', ['SettingsService', require('./settings-html-directive')])
    .directive('wowContentSetting', ['SettingsService', '$templateCache', 'BreakpointsService', '$location', require('./content-setting-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/settings/index.js
 **/